import { apiInstance, apiResponse, getLoadingState } from '../../Api';
import { MonografiaModel } from './Model';

export const fetchMonografiaDoAlunoAtual = async (): Promise<apiResponse<
  MonografiaModel | undefined
>> => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel>(
      '/aluno/monografia'
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const fetchMonografiaDoAluno = async (alunoId: number): Promise<apiResponse<
  MonografiaModel | undefined
>> => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel>(
      `/funcionario/monografia/${alunoId}`
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const fetchMonografiasQuePossuemDeposito = async (
  page: number,
  pageSize: number,
  search: string
): Promise<apiResponse<MonografiaModel[]>> => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel[]>(
      '/funcionario/monografia',
      { params: { page, pageSize, search } }
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel[]>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<MonografiaModel[]>;
  }
};

export const fetchProfessorMonografias = async () => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel[]>(
      '/professor/monografia'
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel[]>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<MonografiaModel[]>;
  }
};

export const fetchProfessorMonografiasJaApresentadas = async () => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel[]>(
      '/professor/monografia/todas'
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel[]>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<MonografiaModel[]>;
  }
};

export const fetchMonografiaDoOrientando = async (
  monografiaId: number
): Promise<apiResponse<MonografiaModel | undefined>> => {
  try {
    const fetchResponse = await apiInstance.get<MonografiaModel>(
      `/professor/monografia/${monografiaId}`
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<MonografiaModel>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;
    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const editarMonografiaDoAluno = async (
  monografiaId: number,
  titulo: string,
  palavrasChave: Array<string>,
  autorizacaoAluno?: boolean
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('/aluno/monografia', {
      MonografiaId: monografiaId,
      Titulo: titulo,
      PalavrasChave: palavrasChave,
      AutorizacaoAluno: autorizacaoAluno
    });

    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const editarTituloMonografiaDoAluno = async (
  monografiaId: number,
  titulo: string,
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('/funcionario/monografia', {
      MonografiaId: monografiaId,
      Titulo: titulo,
    });

    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const editarSituacaoDepositoDoAluno = async (
  monografiaId: number,
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('/funcionario/monografia/deposito', {
      MonografiaId: monografiaId
    });

    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const editarOrientadorMonografiaDoAluno = async (
  monografiaId: number,
  professorId: number,
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('/funcionario/monografia/orientador', {
      MonografiaId: monografiaId,
      ProfessorId: professorId,
    });

    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};

export const editarNotaMonografiaDoAluno = async (
  monografia: {
    notaOrientador: number,
    notaConvidado: number,
    observacao: string,
    autorizacaoProfessor: boolean
  },
  monografiaId: number
): Promise<apiResponse<undefined>> => {
  try {
    const result = await apiInstance.post('/monografia/nota', {
      NotaOrientador: monografia.notaOrientador,
      NotaConvidado: monografia.notaConvidado,
      Observacao: monografia.observacao,
      MonografiaId: monografiaId,
      AutorizacaoProfessor: monografia.autorizacaoProfessor
    });
    return {
      status: getLoadingState(result.status)
    } as apiResponse<undefined>;
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      status: getLoadingState(status)
    } as apiResponse<undefined>;
  }
};
